export const isYouTube = (url: string) => {
    return url.includes("youtube.com") || url.includes("youtu.be");
}